if (!customElements.get('collapsible-collage-item')) {
  class CollapsibleCollageItem extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.collapsible-collage__toggle');
      this.toggle?.addEventListener('click', () => this._handleClick());
    }

    _handleClick() {
      const isOpen = this.toggle.getAttribute('aria-expanded') === 'true';

      if (!isOpen) {
        this.closest('.collapsible-collage__items')
          ?.querySelectorAll('collapsible-collage-item')
          .forEach((item) => {
            if (item !== this) item._close();
          });
        this._open();
      } else {
        this._close();
      }
    }

    _open() {
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    _close() {
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('collapsible-collage-item', CollapsibleCollageItem);
}
